// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6943d5f1","269":"8ffb2e9e","322":"e03bfd4d","396":"a234c3dc","667":"ab7c81e0","950":"b0699933","977":"4c5fa128"}[chunkId] + ".chunk.js";
};